import { DialogController } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';
import { DialogHandler, MnDialog } from 'lib/ui';
import { HourProductionOrderDto, MooringProductionTaskType } from 'models/mooring';
import { CreateEditHourItemDialog } from './create-edit-hour-item-dialog';

export type HourListDialogArgs = {
  productionOrderId: number;
  /**
   * Passing this will override the default task options (which is all tasks).
   */
  taskOptions?: MooringProductionTaskType[];
};

@autoinject
export class HourListDialog extends MnDialog<HourListDialogArgs, void> {
  protected loading = true;

  protected productionOrderId?: number;
  protected taskOptions?: MooringProductionTaskType[];

  protected hours: HourProductionOrderDto[] = [];

  constructor(
    dc: DialogController,
    private dialog: DialogHandler
  ) {
    super(dc);
  }

  activate(args?: HourListDialogArgs) {
    if (!args || !args.productionOrderId) return;
    this.productionOrderId = args.productionOrderId;
    this.taskOptions = args.taskOptions;
  }

  protected async onAddHour() {
    await this.dialog.open(CreateEditHourItemDialog, {
      productionOrderId: this.productionOrderId,
      taskOptions: this.taskOptions,
    });
  }
}
